import { DoorOpen } from "lucide-react";
import { CrudPage } from "../components/crud/CrudPage";
import { Badge } from "../components/ui/Badge";

const tiposEspacio = [
  { value: "JAULA", label: "Jaula" },
  { value: "CUARTO", label: "Cuarto" },
  { value: "CORRAL", label: "Corral" },
  { value: "PATIO", label: "Patio" },
];

interface Espacio {
  id: string;
  nombre: string;
  tipo: string;
  capacidad: number;
  disponible: boolean;
}

// Jaulas, cuartos, corrales y patios que se pueden asignar a un hospedaje o
// guardería. Este catálogo alimenta el selector "Espacio asignado" del
// formulario de hospedaje.
export default function Espacios() {
  return (
    <CrudPage<Espacio>
      resource="/espacios"
          seccion="espacios"
      titulo="Espacios"
          icono={<DoorOpen size={20} />}
      descripcion="Jaulas, cuartos, corrales y patios disponibles para asignar en hospedaje y guardería."
      nombreSingular="espacio"
      campos={[
        { name: "nombre", label: "Nombre", required: true, placeholder: "Ej. Jaula 3, Cuarto A" },
        { name: "tipo", label: "Tipo", type: "select", options: tiposEspacio, required: true, default: "JAULA" },
        { name: "capacidad", label: "Capacidad", type: "number", required: true, default: 1 },
        { name: "disponible", label: "Disponible", type: "checkbox", default: true },
      ]}
      columnas={[
        { key: "nombre", label: "Nombre" },
        { key: "tipo", label: "Tipo", render: (r) => tiposEspacio.find((t) => t.value === r.tipo)?.label ?? r.tipo },
        { key: "capacidad", label: "Capacidad" },
        {
          key: "disponible",
          label: "Estado",
          render: (r) => <Badge color={r.disponible ? "verde" : "gris"}>{r.disponible ? "Disponible" : "Ocupado"}</Badge>,
        },
      ]}
    />
  );
}
